/*

Controller file for payouts

*/
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Payouts = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getPayouts: function(startDate, endDate, callback) {
		var self = this;
		var url = "payouts";
		const params = {
			start_date: moment(startDate).format("YYYY-MM-DD"),
			end_date: moment(endDate).format("YYYY-MM-DD")
		}
		// #  Send to server object for processing
		var data = self.server.getData(url, params, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    },
    getOwnerPayouts: function(callback) {
		var self = this;
		var url = "owner/payouts";
		// #  Send to server object for processing
		var data = self.server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    }
});

export let payouts = new Payouts();


// WEBPACK FOOTER //
// app/core/controllers/Payouts.js